import React, { Component } from 'react';
import './PremiumContentLogin.scss';
import { string } from '../../../localization';
import * as Constants from '../../../utilities/constants/Constants';
import { Modal } from 'reactstrap';

class PremiumContentLogin extends Component {
  state = { loginId: '', password: '' };

  getLoginId = e => {
    this.setState({ loginId: e.target.value });
  };

  getPassword = e => {
    this.setState({ password: e.target.value });
  };

  render() {
    const { loginId, password } = this.state;
    const {
      title,
      subTitle,
      newAccountHint,
      signOrRegBtnName,
      modalIsOpen,
      close,
      imageSourceIcon,
      registerImage,
      imageSource,
      login,
      loginErrorMessage,
      handleRegisterWindow
    } = this.props;
    return (
      <Modal
        modalClassName='permium-content-login-modal'
        backdropClassName='permium-content-login-backdrop'
        isOpen={modalIsOpen}
        centered
      >
        <div className='premium-content-login-vanilla'>
          <div className='header'>
            <button
              type='button'
              aria-label='close'
              className='close-icon'
              onClick={() => close(false)}
            />
          </div>
          <div className='body'>
            <p className='title'>{title}</p>
            <p className='sub-title'>{subTitle}</p>
            <div className='d-flex align-items-center justify-content-bwteen'>
              <div className='login'>
                <p className='sub-title'>
                  {Constants.ASTERISK}
                  {string.REQUIRED_FIELDS_TEXT_KEY}
                </p>
                <input
                  placeholder={string.LOGIN_KEY + Constants.ASTERISK}
                  onChange={e => this.getLoginId(e)}
                />

                <input
                  type='password'
                  placeholder={string.PASSWORD_KEY + Constants.ASTERISK}
                  onChange={e => this.getPassword(e)}
                />
                {imageSource === Constants.DREAMSTIME_IMAGE_SOURCE ? null : (
                  <div className='mb-3'>
                    <button
                      type='button'
                      style={{
                        border: 'none',
                        background: 'none',
                        outline: 'none'
                      }}
                      className='info'
                      onClick={() =>
                        window.open(Constants.FORGOT_PASSWORD_PATTERN, '_blank')
                      }
                    >
                      {string.FORGOT_PASSWORD_KEY}
                    </button>
                  </div>
                )}
                <button
                  type='button'
                  className='button flow-primary-default'
                  onClick={() => login(loginId, password, imageSource)}
                >
                  {string.LOGIN_KEY}
                </button>
                <div className='error-message'>{loginErrorMessage}</div>
              </div>
              <div className='text-center'>
                <img className='mb-3' src={imageSourceIcon} alt='imageSource' />{' '}
                <br />
                {imageSource === Constants.PATTERN_DESIGN_IMAGE_SOURCE ? (
                  <span>
                    <span className='description title'>
                      {string.HIGH_QUALITY_KEY}
                    </span>{' '}
                    <span className='description sub-title'>
                      {string.AND_KEY}
                    </span>{' '}
                    <br />
                    <span className='description title'>
                      {string.ROYALTY_FREE_KEY}
                    </span>{' '}
                    <span className='description sub-title'>
                      {string.SEAMLESS_KEY}
                    </span>
                    <br />
                    <span className='description title'>
                      {string.VECTOR_KEY}
                    </span>{' '}
                    <span className='description sub-title'>
                      {string.PATTERNS_FOR_KEY}
                    </span>{' '}
                    <br />
                    <span className='description title'>
                      {string.PROFESSIONAL_USE_TITLE_KEY}
                    </span>{' '}
                  </span>
                ) : (
                  <span>
                    <span className='description title'>
                      {string.HIGH_QUALITY_KEY}
                    </span>{' '}
                    <span className='description sub-title'>
                      {string.AND_KEY}
                    </span>{' '}
                    <br />
                    <span className='description title'>
                      {string.ROYALTY_FREE_KEY}
                    </span>{' '}
                    <br />
                    <span className='description title'>
                      {string.DREAMSTIME_IMAGES_KEY}
                    </span>{' '}
                    <span className='description sub-title'>
                      {string.FOR_KEY}
                    </span>{' '}
                    <br />
                    <span className='description title'>
                      {string.PROFESSIONAL_USE_TITLE_KEY}
                    </span>{' '}
                  </span>
                )}
              </div>
              <div className='pattern-designr-register'>
                <img src={registerImage} alt='register' />
              </div>
            </div>
            <div className='bottom-container'>
              <div className='sub-title'>{newAccountHint}</div>

              <button
                type='button'
                onClick={() => handleRegisterWindow(true, imageSource)}
                className='button nutral-primary-default'
              >
                {signOrRegBtnName}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default PremiumContentLogin;
